import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getK3Tasks, setK3Tasks, getK3Agents, getK3TaskLogs, getK3Scripts } from '../../actions';
import {
  Button,
  Card,
  Form,
  InputGroup,
  Row,
  Col,
  Badge,
  Spinner,
  ProgressBar,
  Modal
} from 'react-bootstrap';
import { BsSearch, BsPlus, BsFilter, BsFiles, BsList, BsCode } from 'react-icons/bs';
import K3TaskCreator from './K3TaskCreator';
import K3TaskView from './K3TaskView';
import K3TaskLogModal from '../../components/K3/K3TaskLogModal';
import K3ModalViewSource from '../../components/K3/K3ModalViewSource';
import K3TaskCreateModal from './K3TaskCreateModal';
import Pagination from '../../components/Pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import { getK3Docs as getK3DocsService } from '../../services/k3docService';

class K3TaskList extends Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(window.location.search);
    
    this.state = {
      searchKeyword: searchParams.get('q') || '',
      showCreator: false,
      showViewer: false,
      selectedTask: null,
      filters: {
        type: searchParams.get('type') || '',
        status: searchParams.get('status') || '',
        src_agent_id: searchParams.get('src_agent') || '',
        target_agent_id: searchParams.get('target_agent') || ''
      },
      showLogModal: false,
      selectedTaskForLogs: null,
      showSourceModal: false,
      selectedTaskForSource: null,
      showCreateModal: false,
      currentPage: parseInt(searchParams.get('page')) || 1,
      tasksPerPage: parseInt(searchParams.get('limit')) || 12,
      sortBy: searchParams.get('sort') || 'updatedAt',
      sortOrder: searchParams.get('order') || 'desc',
      configFields: null,
      initialCustomType: null
    };
  }

  componentDidMount() {
    this.loadTasks();
    this.props.getK3Agents();
    this.props.getK3Scripts();

    // Fetch UI config for type dropdown (like K3DocList)
    getK3DocsService({ docMid: 'UI_CONFIG_FIELDS_K3TASK' })
      .then(response => {
        const data = response.data.data.docs;
        if (data && data.length > 0 && data[0].content) {
          try {
            const configFields = JSON.parse(data[0].content);
            this.setState({ configFields }, this.syncInitialCustomType);
          } catch (error) {
            console.error('Error parsing config fields:', error);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching config fields:', error);
      });
  }

  syncInitialCustomType = () => {
    const { filters, configFields } = this.state;
    if (!configFields || !configFields.type) return;
    if (filters.type && !configFields.type.options.some(opt => opt.value === filters.type)) {
      this.setState({ initialCustomType: filters.type });
    } else {
      this.setState({ initialCustomType: null });
    }
  };

  updateURL = () => {
    const { searchKeyword, filters, currentPage, tasksPerPage, sortBy, sortOrder } = this.state;
    const searchParams = new URLSearchParams();

    if (searchKeyword) searchParams.set('q', searchKeyword);
    if (filters.type) searchParams.set('type', filters.type);
    if (filters.status) searchParams.set('status', filters.status);
    if (filters.src_agent_id) searchParams.set('src_agent', filters.src_agent_id);
    if (filters.target_agent_id) searchParams.set('target_agent', filters.target_agent_id);
    if (currentPage > 1) searchParams.set('page', currentPage);
    if (tasksPerPage !== 12) searchParams.set('limit', tasksPerPage);
    if (sortBy !== 'updatedAt') searchParams.set('sort', sortBy);
    if (sortOrder !== 'desc') searchParams.set('order', sortOrder);

    const newURL = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
    window.history.pushState({}, '', newURL);
  };

  loadTasks = () => {
    const { searchKeyword, filters, currentPage, tasksPerPage, sortBy, sortOrder } = this.state;
    const query = {
      keyword: searchKeyword.trim(),
      ...filters,
      page: currentPage,
      limit: tasksPerPage,
      sort_by: sortBy,
      sort_order: sortOrder
    };
    this.props.getK3Tasks(query);
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({ currentPage: 1 }, () => {
      this.loadTasks();
      this.updateURL();
    });
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      },
      currentPage: 1
    }), () => {
      if (name === 'type') this.syncInitialCustomType();
      this.loadTasks();
      this.updateURL();
    });
  };

  handleSortChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      this.loadTasks();
      this.updateURL();
    });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.loadTasks();
      this.updateURL();
    });
  };

  handleTasksPerPageChange = (e) => {
    const tasksPerPage = parseInt(e.target.value);
    this.setState({ tasksPerPage, currentPage: 1 }, () => {
      this.loadTasks();
      this.updateURL();
    });
  };

  handleViewTask = (task) => {
    this.setState({
      selectedTask: task,
      showViewer: true
    });
  };

  handleShowLogs = (task) => {
    this.setState({
      selectedTaskForLogs: task,
      showLogModal: true
    });

    // Fetch logs for the selected task
    this.props.getK3TaskLogs({ task_id: task._id });
  };

  handleHideLogs = () => {
    this.setState({
      selectedTaskForLogs: null,
      showLogModal: false
    });
  };

  handleCopyTask = async (task) => {
    try {
      // Extract number from name if exists
      const nameMatch = task.name.match(/^(.*?)\s*\((\d+)\)$/);
      let newName;
      if (nameMatch) {
        const baseName = nameMatch[1];
        const number = parseInt(nameMatch[2]) + 1;
        newName = `${baseName} (${number})`;
      } else {
        newName = `${task.name} (2)`;
      }

      // Create new task object
      const newTask = {
        ...task,
        name: newName,
        action_count: 0,
        status: 'pending',
        progress: 0,
        start_time: null,
        updated_time: null,
        finish_time: null
      };

      // Remove fields that should not be copied
      delete newTask._id;
      delete newTask.createdAt;
      delete newTask.updatedAt;
      delete newTask.parent_task_id;
      delete newTask.children_task_ids;

      await this.props.setK3Tasks([newTask]);
      this.props.getK3Tasks();
    } catch (error) {
      console.error('Error copying task:', error);
    }
  };

  handleShowSource = (task) => {
    this.setState({
      selectedTaskForSource: task,
      showSourceModal: true
    });
  };

  handleHideSource = () => {
    this.setState({
      selectedTaskForSource: null,
      showSourceModal: false
    });
  };

  handleCreateTask = async (taskData) => {
    try {
      await this.props.setK3Tasks([taskData]);
      await this.props.getK3Tasks();
    } catch (error) {
      console.error('Error creating task:', error);
    }
  };

  getStatusBadge = (status) => {
    const variants = {
      pending: 'secondary',
      running: 'primary',
      completed: 'success',
      failed: 'danger',
      cancelled: 'warning'
    };
    return <Badge bg={variants[status]}>{status}</Badge>;
  };

  getAgentName = (agentId) => {
    const agent = this.props.k3agents.find(a => a._id === agentId);
    return agent ? `${agent.name}` : 'Unknown';
  };

  render() {
    const { k3tasks, totalTasks, loading, k3agents, k3scripts } = this.props;
    const {
      searchKeyword,
      showCreator,
      showViewer,
      selectedTask,
      filters,
      showLogModal,
      selectedTaskForLogs,
      showSourceModal,
      selectedTaskForSource,
      showCreateModal,
      currentPage,
      tasksPerPage,
      sortBy,
      sortOrder,
      configFields,
      initialCustomType
    } = this.state;

    const totalPages = Math.ceil((totalTasks || 0) / tasksPerPage);

    // Helper to get label for type value
    const getTypeLabel = (value) => {
      if (configFields && configFields.type && configFields.type.options) {
        const found = configFields.type.options.find(opt => opt.value === value);
        return found ? found.label : value;
      }
      return value;
    };

    return (
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col md={8}>
            <Form onSubmit={this.handleSearch}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search tasks..."
                  value={searchKeyword}
                  onChange={(e) => this.setState({ searchKeyword: e.target.value })}
                />
                <Button variant="outline-secondary" type="submit">
                  <BsSearch />
                </Button>
              </InputGroup>
            </Form>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="primary"
              onClick={() => this.setState({ showCreateModal: true })}
            >
              <BsPlus className="me-1" /> New Task
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={3}>
            <Form.Select
              name="type"
              value={filters.type}
              onChange={this.handleFilterChange}
              className="w-auto"
            >
              <option value="">All Types</option>
              {this.state.configFields && this.state.configFields.type ? (
                (() => {
                  let typeOptions = this.state.configFields.type.options;
                  if (this.state.initialCustomType && !typeOptions.some(opt => opt.value === this.state.initialCustomType)) {
                    typeOptions = [{ value: this.state.initialCustomType, label: this.state.initialCustomType }, ...typeOptions];
                  }
                  return typeOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ));
                })()
              ) : (
                this.props.k3scripts && this.props.k3scripts.map(script => (
                  <option key={script._id} value={script.type}>
                    {script.type}
                  </option>
                ))
              )}
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={this.handleFilterChange}
              className="w-auto"
            >
              <option value="">All Statuses</option>
              <option value="pending">Pending</option>
              <option value="running">Running</option>
              <option value="completed">Completed</option>
              <option value="failed">Failed</option>
              <option value="cancelled">Cancelled</option>
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select
              name="src_agent_id"
              value={filters.src_agent_id}
              onChange={this.handleFilterChange}
              className="w-auto"
            >
              <option value="">All Source Agents</option>
              {k3agents && k3agents.map(agent => (
                <option key={agent._id} value={agent._id}>
                  {agent.name}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select
              name="target_agent_id"
              value={filters.target_agent_id}
              onChange={this.handleFilterChange}
              className="w-auto"
            >
              <option value="">All Target Agents</option>
              {k3agents && k3agents.map(agent => (
                <option key={agent._id} value={agent._id}>
                  {agent.name}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-muted">
                Found {totalTasks || 0} {totalTasks === 1 ? 'task' : 'tasks'}
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Sort by:</span>
                  <Form.Select
                    name="sortBy"
                    value={sortBy}
                    onChange={this.handleSortChange}
                    className="w-auto"
                  >
                    <option value="updatedAt">Updated At</option>
                    <option value="createdAt">Created At</option>
                    <option value="name">Name</option>
                    <option value="type">Type</option>
                    <option value="status">Status</option>
                  </Form.Select>
                  <Form.Select
                    name="sortOrder"
                    value={sortOrder}
                    onChange={this.handleSortChange}
                    className="w-auto"
                  >
                    <option value="asc">Ascending</option>
                    <option value="desc">Descending</option>
                  </Form.Select>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Tasks per page:</span>
                  <Form.Select
                    value={tasksPerPage}
                    onChange={this.handleTasksPerPageChange}
                    style={{ width: 'auto' }}
                  >
                    <option value={12}>12</option>
                    <option value={24}>24</option>
                    <option value={48}>48</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <Row>
              {k3tasks.map(task => (
                <Col key={task._id} lg={3} md={4} sm={6} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <Card.Title className="text-truncate mb-2" title={task.name || task.type}>
                        <h5>{task.name || getTypeLabel(task.type)}</h5>
                      </Card.Title>
                      <div className="small text-muted mb-2">
                        <div>Type: {getTypeLabel(task.type)}</div>
                        <div className="mt-2">
                          <div>Source Agent: {this.getAgentName(task.src_agent_id)}</div>
                          <div>Target Agent: {this.getAgentName(task.target_agent_id)}</div>
                        </div>
                        <div className="mt-2">
                          <div>Created: {new Date(task.createdAt).toLocaleString()}</div>
                        </div>
                        <div>
                          <div>Updated: {new Date(task.updatedAt).toLocaleString()}</div>
                        </div>
                      </div>
                      <ProgressBar now={task.progress} className="mb-3" />
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="w-auto"
                          onClick={() => this.handleViewTask(task)}
                        >
                          View
                        </Button>
                        <Button
                          variant="outline-info"
                          size="sm"
                          className="w-auto"
                          onClick={() => this.handleShowLogs(task)}
                        >
                          <BsList className="me-1" /> Logs
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="w-auto"
                          onClick={() => this.handleCopyTask(task)}
                        >
                          <BsFiles className="me-1" /> Clone
                        </Button>
                        <Button
                          variant="outline-dark"
                          size="sm"
                          className="w-auto"
                          onClick={() => this.handleShowSource(task)}
                        >
                          <BsCode className="me-1" /> Source
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {totalPages > 1 && (
              <Row className="mt-4">
                <Col>
                  <div className="d-flex justify-content-center">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => this.handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPages)].map((_, index) => (
                          <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => this.handlePageChange(index + 1)}
                            >
                              {index + 1}
                            </button>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => this.handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Col>
              </Row>
            )}
          </>
        )}

        <K3TaskCreateModal
          show={showCreateModal}
          onHide={() => this.setState({ showCreateModal: false })}
          k3agents={k3agents}
          k3scripts={k3scripts}
          onCreateTask={this.handleCreateTask}
        />

        {showViewer && selectedTask && (
          <K3TaskView
            show={showViewer}
            onHide={() => this.setState({ showViewer: false, selectedTask: null })}
            selectedTask={selectedTask}
          />
        )}

        {selectedTaskForLogs && (
          <div className="modal-top">
            <K3TaskLogModal
              show={showLogModal}
              onHide={this.handleHideLogs}
              task={selectedTaskForLogs}
            />
          </div>
        )}

        <K3ModalViewSource
          show={showSourceModal}
          onHide={this.handleHideSource}
          data={selectedTaskForSource}
          title="Task Source"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  k3tasks: state.k3taskReducer.k3tasks,
  totalTasks: state.k3taskReducer.totalTasks,
  loading: state.k3taskReducer.loading,
  k3agents: state.k3agentReducer.k3agents,
  k3scripts: state.k3scriptReducer.scripts
});

export default connect(mapStateToProps, { 
  getK3Tasks, 
  setK3Tasks, 
  getK3Agents, 
  getK3TaskLogs,
  getK3Scripts
})(K3TaskList); 